export default "__VITE_ASSET__BIROaUKR__"